import { addReceiverIdFns } from "../receivers";
export function getMessages(type, selectionsCount, items) {
    const cache = {
        addSelection: {
            items: [],
            receiverIds: []
        },
        removeSelection: {
            items: [],
            receiverIds: []
        },
        clear: {
            items: [],
            receiverIds: []
        }
    };
    addReceiverIdFns.forEach(addReceiverIdFn => {
        addReceiverIdFn({
            messageType: type,
            messageCache: cache,
            items,
            selectionsCount
        });
    });
    return Object.keys(cache)
        .filter(key => cache[key].receiverIds.length > 0)
        .map(key => {
        return {
            type: key,
            items: cache[key].items,
            receiverIds: cache[key].receiverIds
        };
    });
}
//# sourceMappingURL=getMessages.js.map